import { ContractType, ServiceType } from "../type/security.type";
import { UserType } from "../type/user.type";
import { SERVICES_LIST } from "../constants/services";

const getSignalServices = (services: ServiceType) => Object.keys(services).filter((serviceCode: string) =>
        SERVICES_LIST.includes(serviceCode),
);

export const getContract = (user: UserType): ContractType | undefined => {
    if (user.data) {
        const signalServices = getSignalServices(user.data.services)
        if (signalServices && signalServices.length > 0) {
            let userSignalServices = user.data?.services[signalServices[0]]
            let filterOnContracts = userSignalServices.filter((context: ContractType) => context.type === 'contract')

            return filterOnContracts[0] ?? userSignalServices[0] // contract id or first signal service
        }
    }
    return undefined;
}

export const getOrganization = (user: UserType): ContractType | undefined => {
    if (user.data) {
        const signalServices = getSignalServices(user.data.services)
        if (signalServices && signalServices.length > 0) {
            let userSignalServices = user.data?.services[signalServices[0]]
            let filterOnOrganizations = userSignalServices.filter((context: ContractType) => context.type === 'organization')

            return filterOnOrganizations[0] ?? userSignalServices[0] // organization id or first signal service
        }
    }
    return undefined;
}
